import { extensionToMime } from 'filestack-js';
import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as Str from 'fp-ts/string';
export var uniqTypesFromExts = function uniqTypesFromExts(extentions) {
  return pipe(extentions, A.filterMap(function (ext) {
    var mime = extensionToMime(ext);
    if ((ext === null || ext === void 0 ? void 0 : ext.length) > 0) return O.fromNullable(mime);
    return O.none;
  }), A.uniq(Str.Eq));
};
export var fileTypeExt = ['.key', '.odp', '.pps', '.ppt', '.pdf', '.ods', '.xlr', '.xls', '.xlsx', '.doc', '.docx', '.odt', '.rtf', '.tex', '.txt', '.wks', '.wps', '.wpd'];
export var videoTypeExt = ['.mp4', '.mov', '.wmv', '.avi'];
export var imageTypeExt = ['.jpeg', '.jpg', '.png'];
export var fileTypes = uniqTypesFromExts(fileTypeExt);
export var videoTypes = uniqTypesFromExts([].concat(videoTypeExt, ['video/vnd.avi']));
export var imageTypes = uniqTypesFromExts(imageTypeExt);
export var previewVideoTypes = uniqTypesFromExts(['mp4', 'mov']);